// src/api/collection/collectionApi.ts
import { axiosInstance } from "src/api/axiosInstance";

import type {
  ApiResponse,
  ServerPageContent, // ✅ 추가
  CollectionNode,
  CollectionHierarchyQuery,
  CollectionUpsertPayload,
} from "src/types/collection/collectionTypes";

const BASE = "/v1/admin/baseinfo/collection";
export const getCollectionHierarchyApi = async (
  params: CollectionHierarchyQuery
): Promise<ApiResponse<ServerPageContent<CollectionNode>>> => {
  // ✅ 여기 수정
  const res = await axiosInstance.get<ApiResponse<ServerPageContent<CollectionNode>>>(
    `${BASE}/hierarchy`,
    {
      params: {
        ...params,
        collectionName: params.collectionName || undefined,
        parentCollectionId:
          typeof params.parentCollectionId === "number" ? params.parentCollectionId : undefined,
        depth: typeof params.depth === "number" ? params.depth : undefined,
        isActive: typeof params.isActive === "boolean" ? params.isActive : undefined,
        isFeatured: typeof params.isFeatured === "boolean" ? params.isFeatured : undefined,
        order: params.order || "displayOrder,asc",
      },
    }
  );
  return res.data;
};
export const getCollectionApi = async (id: number): Promise<ApiResponse<CollectionNode>> => {
  const res = await axiosInstance.get<ApiResponse<CollectionNode>>(`${BASE}/${id}`);
  return res.data;
};

type MultipartKeys = {
  dataKey?: string; // default "data"
  fileKey?: string; // default "file"
};

// 예: src/api/collection/collectionApi.ts

const normalizeCollectionPayload = (payload: CollectionUpsertPayload): CollectionUpsertPayload => {
  return {
    ...payload,
    parentCollectionId:
      payload.parentCollectionId === 0 ? (null as any) : payload.parentCollectionId,
  };
};

const buildCollectionFormData = (
  payload: CollectionUpsertPayload,
  thumbnailFile?: File | null,
  keys: MultipartKeys = {}
) => {
  const { dataKey = "data", fileKey = "thumbnailFile" } = keys;
  const fd = new FormData();

  const normalized = normalizeCollectionPayload(payload);

  fd.append(dataKey, new Blob([JSON.stringify(normalized)], { type: "application/json" }));
  if (thumbnailFile) fd.append(fileKey, thumbnailFile);

  return fd;
};
export const createCollectionApi = async (
  payload: CollectionUpsertPayload,
  thumbnailFile?: File | null,
  keys?: MultipartKeys
): Promise<ApiResponse<null>> => {
  const formData = buildCollectionFormData(payload, thumbnailFile, keys);
  const res = await axiosInstance.post<ApiResponse<null>>(`${BASE}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const updateCollectionApi = async (
  id: number,
  payload: CollectionUpsertPayload,
  thumbnailFile?: File | null,
  keys?: MultipartKeys
): Promise<ApiResponse<null>> => {
  const formData = buildCollectionFormData(payload, thumbnailFile, keys);
  const res = await axiosInstance.put<ApiResponse<null>>(`${BASE}/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const deleteCollectionApi = async (id: number): Promise<ApiResponse<null>> => {
  const res = await axiosInstance.delete<ApiResponse<null>>(`${BASE}/${id}`);
  return res.data;
};
